import { memo } from 'react';
import { IconButton } from 'components';

import { useResponsive } from 'hooks/useResponsive';
import styles from './FilledBottomSection.module.scss';

interface FilledBottomSectionProps {
  id: string;
  title: string;
  startDate: string;
  endDate: string;
  description: string | string[];
  isLast?: boolean;
  onEditClick?: () => void;
  graduationYear?: string;
}

export const FilledBottomSection: React.FC<FilledBottomSectionProps> = memo(
  ({
    title,
    startDate,
    endDate,
    description,
    isLast,
    onEditClick,
    graduationYear,
  }: FilledBottomSectionProps) => {
    const screens = useResponsive();

    return (
      <article className={styles['main-container']}>
        <section className={styles['education-container']}>
          <section className={styles['title-container']}>
            <section className={styles.main}>
              <div className={styles.title}>{title}</div>
              <div className={styles['date-and-edit']}>
                <div className={styles.date}>
                  {startDate ? `${startDate} - ` : ''}
                  {endDate || graduationYear}
                </div>
                <IconButton
                  iconName="icon_pencil-filled"
                  size="xsmallplus"
                  onClick={onEditClick}
                  className={styles['edit-icon']}
                />
              </div>
            </section>
          </section>

          {screens.sm_desktop_down && (
            <div className={styles['date-down']}>
              {startDate ? `${startDate} - ` : ''}
              {endDate || graduationYear}
            </div>
          )}

          <section className={styles['description-container']}>
            <section className={styles['inner-container']}>
              <p>{description}</p>
            </section>
          </section>
        </section>

        {!isLast && <div className={styles['line-divider']}></div>}
      </article>
    );
  }
);

FilledBottomSection.displayName = 'FilledBottomSection';
